import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const Unauthorized: React.FC = () => (
  <div className="w-full mt-12 px-4">
    <Card>
      <CardHeader>
        <CardTitle>Unauthorized</CardTitle>
        <CardDescription>You do not have permission to view this page.</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">Ask an administrator for access.</p>
      </CardContent>
      <CardFooter>
        <Button asChild>
          <Link to="/">Return home</Link>
        </Button>
      </CardFooter>
    </Card>
  </div>
);

export default Unauthorized;
